import m from 'm';

import analyticsMenu from 'components/analytics.menu';
import reactCreator from 'components/react.creator';
import menu from 'pages/menu';

const component = {};

component.view = function view() {
  return m('.analytics-page', [
    m('.analytics-page__menu', [m(menu), m(analyticsMenu)]),
    m('.analytics-page__body', [
      m(reactCreator, {
        component: 'Dashboard'
      })
    ])
  ]);
};

export default component;
